import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PREDEFINED_TASKS_LIST } from "./apiRoutes";

export interface PredefinedTask {
  id: string;
  taskName: string;
  taskCategory: string;
  priority: string;
  taskTerm: string;
  taskDescription?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PredefinedTasksResponse {
  data: [
    {
      records: PredefinedTask[];
      pagination: [
        {
          totalRecords: number;
          page: number;
          limit: number;
        }
      ];
    }
  ];
  message: string;
  success: boolean;
}

export interface GetPredefinedTasksParams {
  page?: number;
  limit?: number;
  taskName?: string;
  taskCategory?: string;
  priority?: string;
  taskTerm?: string;
  orderBy?: string;
  orderDirection?: string;
}

const fetchPredefinedTasks = async (params: GetPredefinedTasksParams = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.taskName) queryParams.append('taskName', params.taskName);
  if (params.taskCategory) queryParams.append('taskCategory', params.taskCategory);
  if (params.priority) queryParams.append('priority', params.priority);
  if (params.taskTerm) queryParams.append('taskTerm', params.taskTerm);
  if (params.orderBy) queryParams.append('orderBy', params.orderBy);
  if (params.orderDirection) queryParams.append('orderDirection', params.orderDirection);

  const url = queryParams.toString() 
    ? `${PREDEFINED_TASKS_LIST}?${queryParams.toString()}`
    : PREDEFINED_TASKS_LIST;

  const response = await axiosAuth.get<PredefinedTasksResponse>(url);
  return response.data;
};

export const useGetPredefinedTasksQuery = (
  params: GetPredefinedTasksParams = {},
  options?: Omit<UseQueryOptions<PredefinedTasksResponse, Error, PredefinedTasksResponse, QueryKey>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["predefinedTasks", params],
    queryFn: () => fetchPredefinedTasks(params),
    ...options,
  });
};
